export default {
    namespaced: true,
    actions: {
        feedback({ commit }, { name, email, phone, type, body }) {
            return window.axios.post('/feedback', { name, email, phone, type, body }).then((res) => {
                return res.data
            })
        }
    }
}